import classnames from 'classnames';
import s from './index.module.scss';

export const Checkbox = ({ children, ...checkboxProps }) => (
  <label
    className={classnames(s.label, checkboxProps.className)}
    htmlFor={checkboxProps.name}
  >
    <CheckboxInput {...checkboxProps} />
    {children}
  </label>
);

export const CheckboxInput = checkboxProps => {
  return (
    <span className={s.checkbox}>
      <input
        type="checkbox"
        className={s.checkbox__input}
        id={checkboxProps.id || checkboxProps.name}
        {...checkboxProps}
      />
      <span className={s.checkbox__checkmark}>
        <svg
          width="10"
          height="8"
          viewBox="0 0 10 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.625 0.4C9.125 -0.133333 8.375 -0.133333 7.875 0.4L3.75 4.8L2.125 3.06667C1.625 2.53333 0.875 2.53333 0.375 3.06667C-0.125 3.6 -0.125 4.4 0.375 4.93333L2.875 7.6C3.125 7.86667 3.375 8 3.75 8C4.125 8 4.375 7.86667 4.625 7.6L9.625 2.26667C10.125 1.73333 10.125 0.933333 9.625 0.4Z"
            fill="#17232D"
          />
        </svg>
      </span>
    </span>
  );
};
